import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

const hotMovies = movies.filter((m) => m.isHot).slice(0, 6);
const newMovies = movies.filter((m) => m.isNew).slice(0, 6);

export default function FeaturedSection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-[var(--font-heading)]">
                热门推荐
              </h2>
              <p className="text-sm text-foreground-500 mt-1">最受欢迎的影片，大家都在看</p>
            </div>
            <Link
              to="/category/action"
              className="text-sm text-accent-600 hover:text-accent-700 font-medium whitespace-nowrap flex items-center gap-1"
            >
              查看更多 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5" data-product-shop="">
            {hotMovies.map((movie) => (
              <Link
                key={movie.id}
                to={`/article/${movie.id}`}
                className="group cursor-pointer"
              >
                <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3">
                  <img
                    src={movie.posterUrl}
                    alt={movie.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-2 left-2">
                    <span className="px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
                      {movie.rating}
                    </span>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
                    <span className="px-4 py-1.5 bg-accent-500 text-background-50 rounded-full text-xs font-medium whitespace-nowrap">
                      <i className="ri-play-circle-line mr-1"></i>立即播放
                    </span>
                  </div>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-accent-600 transition-colors line-clamp-1">
                  {movie.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{movie.year} · {movie.category}</p>
              </Link>
            ))}
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-[var(--font-heading)]">
                最新上映
              </h2>
              <p className="text-sm text-foreground-500 mt-1">刚刚上线的热门新片</p>
            </div>
            <Link
              to="/category/scifi"
              className="text-sm text-accent-600 hover:text-accent-700 font-medium whitespace-nowrap flex items-center gap-1"
            >
              查看更多 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5" data-product-shop="">
            {newMovies.map((movie) => (
              <Link
                key={movie.id}
                to={`/article/${movie.id}`}
                className="group cursor-pointer"
              >
                <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3">
                  <img
                    src={movie.posterUrl}
                    alt={movie.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-2 right-2">
                    <span className="px-2 py-0.5 text-[10px] font-medium bg-green-500 text-white rounded-full whitespace-nowrap">
                      NEW
                    </span>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
                    <span className="px-4 py-1.5 bg-accent-500 text-background-50 rounded-full text-xs font-medium whitespace-nowrap">
                      <i className="ri-play-circle-line mr-1"></i>立即播放
                    </span>
                  </div>
                </div>
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-accent-600 transition-colors line-clamp-1">
                  {movie.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{movie.year} · {movie.category}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}